import { environment } from '../environments/environment'

export class ApiService {
  static api = environment.API_URL
}
